import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import vuetify from './plugins/vuetify'
import { vMaska } from 'maska/vue'
import './assets/tailwind.css'
import router from './router'
import store from './store'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(store)
app.use(vuetify)
app.use(router)
app.directive('maska', vMaska)


store.dispatch('initializeStore')

app.mount('#app')
